import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "position", "showClose", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { Enum, MaxWidthType, PositionBaseType, isArray } from '../../../library';
import { IconClose } from '../../../icons';
import { Overlay } from '../../overlay';
var drawerClasses = {
  MAIN: 'drawer',
  CONTENT: 'drawer__content',
  HEADER: 'drawer__header',
  BODY: 'drawer__body',
  FOOTER: 'drawer__footer'
};
export var DrawerSizeType = Enum(_objectSpread({
  AUTO: 'auto',
  FILL: 'fill'
}, MaxWidthType));
var DrawerHeader = function DrawerHeader(props) {
  return React.createElement("div", {
    className: cn(drawerClasses.HEADER, props.className),
    children: props.children
  });
};
var DrawerBody = function DrawerBody(props) {
  return React.createElement("div", {
    className: cn(drawerClasses.BODY, props.className),
    children: props.children
  });
};
var DrawerFooter = function DrawerFooter(props) {
  return React.createElement("div", {
    className: cn(drawerClasses.FOOTER, props.className),
    children: props.children
  });
};
export var Drawer = function Drawer(props) {
  var children = props.children,
    className = props.className,
    position = props.position,
    showClose = props.showClose,
    size = props.size,
    overlayProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(drawerClasses.MAIN, _defineProperty(_defineProperty({
    '-open': props.isOpen
  }, "-".concat(size), size), "-".concat(position), position), className);
  function getAnimationVariants() {
    var _ref = isArray(props.transitionDuration) ? props.transitionDuration : [props.transitionDuration, props.transitionDuration],
      _ref2 = _slicedToArray(_ref, 2),
      enter = _ref2[0],
      leave = _ref2[1];
    var xOffset = '50%';
    var yOffset = '50%';
    var startingY = props.position === 'top' ? '-' + yOffset : props.position === 'bottom' ? yOffset : 0;
    var startingX = props.position === 'left' ? '-' + xOffset : props.position === 'right' ? xOffset : 0;
    return {
      hidden: {
        opacity: 0,
        translateX: startingX,
        translateY: startingY,
        transition: {
          duration: leave / 1000
        }
      },
      visible: {
        translateX: 0,
        translateY: 0,
        opacity: 1,
        transition: {
          duration: enter / 1000
        }
      }
    };
  }
  return React.createElement(Overlay, overlayProps, React.createElement(motion.div, {
    className: classNames,
    role: "dialog",
    initial: 'hidden',
    animate: props.isOpen ? 'visible' : 'hidden',
    variants: getAnimationVariants()
  }, !!showClose ? React.createElement("button", {
    type: "button",
    className: "close -large -rounded",
    onClick: props.onClose
  }, React.createElement(IconClose, null)) : null, children));
};
Drawer.displayName = 'Drawer';
Drawer.defaultProps = {
  position: PositionBaseType.RIGHT,
  size: DrawerSizeType.AUTO,
  hasBackdrop: true,
  showClose: true,
  transitionDuration: 350
};
Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;